// 配置接口地址
export const api = {
  // 查询布控任务
  queryPersonnelTask: '/vas/personnelControl/queryPersonnelTask.json',
  // 删除布控任务
  deletePersonnelTask: '/vas/personnelControl/deletePersonnelTask.json',
  // 启用/禁用布控任务
  startStopPersonnelTask: '/vas/personnelControl/startStopPersonnelTask.json',
  // 查询布控任务详情
  queryPersonnelTaskDetails: '/vas/personnelControl/queryPersonnelTaskDetails.json',
  // 更新布控任务
  updatePersonnelTask: '/vas/personnelControl/updatePersonnelTask.json',
  // 创建布控任务
  addPersonnelTask: '/vas/personnelControl/addPersonnelTask.json',
  // 请求名单组
  queryGroup: '/vas/faceGroup/queryFaceGroupByType.json'
}
